import { render, staticRenderFns } from "./GetCode.vue?vue&type=template&id=4adc7158&scoped=true"
import script from "./GetCode.vue?vue&type=script&lang=js"
export * from "./GetCode.vue?vue&type=script&lang=js"
import style0 from "./GetCode.vue?vue&type=style&index=0&id=4adc7158&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adc7158",
  null
  
)

export default component.exports